module.exports = __webpack_public_path__ + "static/media/609.a5b93eae.webp";